module.exports = __webpack_public_path__ + "img/Boubakeur.acc0999.png";